import { render } from "./EditGroup.vue?vue&type=template&id=64da92c5"
import script from "./EditGroup.vue?vue&type=script&lang=js"
export * from "./EditGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__